import angular from 'angular'

class accountSubjectCtrl {
    constructor($scope, $uibModal, httpRequest, logger, sweetalert) {
        $scope.queryParam = {
            pageNum: 1,
            pageSize: 10,
            param: {
                kjkmDmAndKjkmmc: '',
            },
        }
        $scope.reset = function reset() {
            $scope.queryParam.param.kjkmDmAndKjkmmc = ''
        }
        // $scope.reset()
        $scope.queryList = function queryList() {
            httpRequest.post_getSbKjkmDmList($scope.queryParam).then((res) => {
                if (res.data.success) {
                    $scope.listData = res.data.value.list
                    $scope.totalItems = res.data.value.total
                }
            })
        }
        $scope.queryList()
        $scope.importconfig = {
            code: 'KJKM',
            validate: {
                pattern: '.xlsx,.xls',
                _validate: {
                    size: { min: 10, max: '10MB' },
                    duration: { min: '10s', max: '5m' },
                    accept: '.xlsx,.xls',
                },
            },
            appName: host.etcloudSb,
            hideDownload: true,
            callback() {
                $scope.queryList()
            },
        }
        $scope.upload = function upload() {
            httpRequest.post_getSbSwkjkmDmList({
                pageNum: 1,
                pageSize: 10,
                param: {
                    swkjkmDmAndSwkjkmmc: '',
                },
            }).then((res) => {
                if (res.data.value.list && res.data.value.list.length > 0) {
                    sweetalert.confirm('操作提醒', '导入后将全面覆盖已有的会计科目表，确定要导入吗？').then(() => {
                        angular.element('#account-subject-upload .plbtngrouptxt').click()
                    })
                } else {
                    logger.logError('请联系管理员先设置税务会计科目')
                }
            })
        }
        $scope.matchSubject = function matchSubject(val) {
            $uibModal.open({
                templateUrl: 'subject-match-modal.html',
                openedClass: 'mod-modal mod-modal-lg',
                controller: ['$scope', '$uibModalInstance', 'httpRequest', 'reqVal', ($scope, $uibModalInstance, httpRequest, reqVal) => {
                    $scope.param = {
                        kmlbDm: 1,
                    }
                    $scope.initList = function initList() {
                        httpRequest.get_getSbSwkjkmDmListByKmlbDm($scope.param).then((res) => {
                            if (res.data.success) {
                                $scope.listData = res.data.value
                            }
                        })
                    }
                    $scope.initList()
                    $scope.tabClick = function tabClick(v) {
                        $scope.param.kmlbDm = v
                        $scope.initList()
                    }
                    $scope.ok = function ok(v) {
                        const req = {
                            kjkmDm: reqVal,
                            swkjkmDm: v,
                        }
                        httpRequest.get_matchSbKjkmDm(req).then((res) => {
                            if (res.data.success) $uibModalInstance.close()
                        })
                    }
                    $scope.cancel = function cancel() {
                        $uibModalInstance.dismiss()
                    }
                }],
                animation: true,
                resolve: {
                    reqVal() {
                        return val
                    },
                },
            }).result.then(() => {
                $scope.queryList()
            })
        }
    }
}

accountSubjectCtrl.$inject = ['$scope', '$uibModal', 'httpRequest', 'logger', 'sweetalert']
export default accountSubjectCtrl



// WEBPACK FOOTER //
// ./src/app/declaration/baseSetting/accountSubject/accountSubjectCtrl.js